import React, { useState, useEffect } from "react";
import { api } from "../lib/api";
import { useParams } from "react-router-dom";
import { Edit, Trash, PlusCircle, Ship, Car, Save, X, Anchor, User, Info, AlertTriangle } from "lucide-react";
import Button from "../components/Button";
import Input from "../components/ui/input";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";
import Label from "../components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { Badge } from "../components/ui/badge";
import { Avatar, AvatarFallback, AvatarImage } from "../components/ui/avatar";
import { ScrollArea } from "../components/ui/scroll-area";
import { toast } from "../components/ui/use-toast";
import Navbar from "../components/Navbar";
import HistorialEmbarcacionesButton from "../components/HistorialEmbarcacionesButton";
import { TIPOS_EMBARCACION } from "../constants/tiposEmbarcacion";

const DetallesClientesPage = () => {
  const { id } = useParams();
  const [cliente, setCliente] = useState(null);
  const [editando, setEditando] = useState(false);
  const [editandoVehiculo, setEditandoVehiculo] = useState(null);
  const [nuevaEmbarcacion, setNuevaEmbarcacion] = useState({
    numeroMatricula: "",
    vencimientoMatricula: "",
    tipoEmbarcacion: "",
    colorCasco: "",
    capacidad: "",
    marca: "",
    hp: "",
    nombreFantasia: "",
    seguro: "",
    vencimientoSeguro: "",
  });
  const [nuevoVehiculo, setNuevoVehiculo] = useState({
    patente: "",
    marca: "",
    anio: "",
    color: "",
  });
  const [editandoEmbarcacion, setEditandoEmbarcacion] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [expandedEmbarcacionId, setExpandedEmbarcacionId] = useState(null);
  const [showNewBoatForm, setShowNewBoatForm] = useState(false);
  const [showNewVehicleForm, setShowNewVehicleForm] = useState(false);
  const [movimientos, setMovimientos] = useState([]);
  const [showAssociateBoatForm, setShowAssociateBoatForm] = useState(false);
const [embarcacionesDisponibles, setEmbarcacionesDisponibles] = useState([]);
const [embarcacionSeleccionada, setEmbarcacionSeleccionada] = useState(null);
const [searchTerm, setSearchTerm] = useState("");

const filteredEmbarcaciones = embarcacionesDisponibles.filter((embarcacion) =>
  (embarcacion.numeroMatricula || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
  (embarcacion.nombreFantasia || '').toLowerCase().includes(searchTerm.toLowerCase())
);

const [showAssociateVehicleForm, setShowAssociateVehicleForm] = useState(false);
const [vehiculosDisponibles, setVehiculosDisponibles] = useState([]);
const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState(null);
const [searchTermVehiculo, setSearchTermVehiculo] = useState("");

const filteredVehiculos = vehiculosDisponibles.filter((vehiculo) =>
  vehiculo && (vehiculo.patente.toLowerCase().includes(searchTermVehiculo.toLowerCase()) ||
  vehiculo.marca.toLowerCase().includes(searchTermVehiculo.toLowerCase()))
);

const [showVehicleDropdown, setShowVehicleDropdown] = useState(false);
const [showVehiclePopup, setShowVehiclePopup] = useState(false);

  const formatDateForInput = (date) => {
    if (!date) return "";

    if (typeof date === "string") {
      if (date.includes("T")) return date.split("T")[0];

      const dashMatch = date.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (dashMatch) return `${dashMatch[1]}-${dashMatch[2]}-${dashMatch[3]}`;

      const slashMatch = date.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
      if (slashMatch) return `${slashMatch[3]}-${slashMatch[2]}-${slashMatch[1]}`;
    }

    const parsedDate = new Date(date);
    return isNaN(parsedDate) ? "" : parsedDate.toISOString().split("T")[0];
  };

  const normalizeEmbarcacionForDisplay = (embarcacion) => {
    const vencimientoMatriculaRaw =
      embarcacion.vencimientoMatricula ||
      embarcacion.fechaVencimiento ||
      embarcacion.matriculaVencimiento;
    const vencimientoSeguroRaw =
      embarcacion.vencimientoSeguro || embarcacion.seguroVencimiento;

    return {
      ...embarcacion,
      vencimientoMatricula: formatDateForInput(vencimientoMatriculaRaw),
      vencimientoSeguro: formatDateForInput(vencimientoSeguroRaw),
    };
  };

  const handleValueChange = (value) => {
    setNuevaEmbarcacion({ ...nuevaEmbarcacion, tipoEmbarcacion: value });
  };

  const handleExpandEmbarcacion = (embarcacionId) => {
    setExpandedEmbarcacionId(expandedEmbarcacionId === embarcacionId ? null : embarcacionId);
  };

  useEffect(() => {
    api
      .get(`/clientes/${id}`)
      .then((response) => {
        const clienteEncontrado = response.data;
        if (clienteEncontrado) {
          clienteEncontrado.embarcaciones =
            (clienteEncontrado.embarcaciones || []).map(
              normalizeEmbarcacionForDisplay
            );
          clienteEncontrado.vehiculos = clienteEncontrado.vehiculos || [];
        }
        setCliente(clienteEncontrado);
      })
      .catch((error) => {
        console.error("Error fetching client details:", error);
      });

    api
      .get(`/movimientos`)
      .then((response) => {
        setMovimientos(response.data);
      })
      .catch((error) => {
        console.error("Error fetching movements:", error);
      });

    api
      .get(`/embarcaciones`)
      .then((response) => {
        setEmbarcacionesDisponibles(response.data);
      })
      .catch((error) => {
        console.error("Error fetching boats:", error);
      });

    api
      .get(`/vehiculos`)
      .then((response) => {
        setVehiculosDisponibles(response.data);
      })
      .catch((error) => {
        console.error("Error fetching vehicles:", error);
      });
  }, [id]);

useEffect(() => {
  api
    .get(`/vehiculos`)
    .then((response) => {
      setVehiculosDisponibles(response.data);
    })
    .catch((error) => {
      console.error("Error fetching vehicles:", error);
    });
}, []);

  if (!cliente) {
    return <div>Loading...</div>;
  }

  const fetchCliente = () => {
  api
    .get(`/clientes/${id}`)
    .then((response) => {
      const clienteEncontrado = response.data;
      clienteEncontrado.embarcaciones =
        (clienteEncontrado.embarcaciones || []).map(
          normalizeEmbarcacionForDisplay
        );
      clienteEncontrado.vehiculos = clienteEncontrado.vehiculos || [];
      setCliente(clienteEncontrado);
    })
    .catch((error) => {
      console.error("Error al actualizar cliente:", error);
    });
};


  const isDateExpired = (date) => {
    const currentDate = new Date();
    const targetDate = new Date(date);
    return targetDate < currentDate;
  };

  const handleEdit = (campo, valor) => {
    setCliente({ ...cliente, [campo]: valor });
  };

  const handleSave = () => {
    api
      .put(`/clientes/${cliente.id}`, cliente)
      .then((response) => {
        setEditando(false);
        toast({
          title: "Cambios guardados",
          description: "Los detalles del cliente han sido actualizados.",
        });
      })
      .catch((error) => {
        console.error("Error al guardar los cambios:", error);
        toast({
          title: "Error",
          description: "Hubo un problema al guardar los cambios.",
          variant: "destructive",
        });
      });
  };

  const handleAgregarEmbarcacion = () => {
    const nuevaEmbarcacionConId = {
      ...nuevaEmbarcacion,
      cliente_id: cliente.id,
    };
  
    api
      .post("/embarcaciones", nuevaEmbarcacionConId)
      .then((response) => {
        const embarcacionGuardada = response.data;
        setCliente((prevCliente) => ({
          ...prevCliente,
          embarcaciones: [...prevCliente.embarcaciones, embarcacionGuardada],
        }));
        fetchCliente();
        setNuevaEmbarcacion({
          numeroMatricula: "",
          vencimientoMatricula: "",
          tipoEmbarcacion: "",
          colorCasco: "",
          capacidad: "",
          marca: "",
          hp: "",
          nombreFantasia: "",
          seguro: "",
          vencimientoSeguro: "",
        });
        toast({
          title: "Embarcación agregada",
          description: `${embarcacionGuardada.nombreFantasia} ha sido agregada a la lista.`,
        });
      })
      .catch((error) => {
        console.error("Error al agregar la embarcación:", error);
        toast({
          title: "Error",
          description: "Hubo un problema al agregar la embarcación.",
          variant: "destructive",
        });
      });
  };
  
  const handleAsociarEmbarcacionMultiple = () => {
    if (!embarcacionSeleccionada) {
      toast({
        title: "Error",
        description: "Debe seleccionar una embarcación.",
        variant: "destructive",
      });
      return;
    }
  
    const clienteIds = [cliente.id]; // Add more client IDs as needed
  
    api
      .post(`/clientes/asociar-embarcacion-multiple`, {
        cliente_ids: clienteIds,
        embarcacion_id: embarcacionSeleccionada,
      })
      .then((response) => {
        const embarcacionAsociada = response.data;
        setCliente((prevCliente) => ({
          ...prevCliente,
          embarcaciones: [...prevCliente.embarcaciones, embarcacionAsociada],
        }));
        fetchCliente();

        setShowAssociateBoatForm(false);
        toast({
          title: "Embarcación asociada",
          description: "La embarcación ha sido asociada correctamente.",
        });
      })
      .catch((error) => {
        console.error("Error al asociar la embarcación:", error);
        toast({
          title: "Error",
          description: "Hubo un problema al asociar la embarcación.",
          variant: "destructive",
        });
      });
  };

  const handleAgregarVehiculo = () => {
    const nuevoVehiculoConId = { ...nuevoVehiculo, cliente_id: cliente.id };
  
    api
      .post("/vehiculos", nuevoVehiculoConId)
      .then((response) => {
        const vehiculoGuardado = response.data;
        setCliente({
          ...cliente,
          vehiculos: [...cliente.vehiculos, vehiculoGuardado],
        });
        setNuevoVehiculo({ patente: "", marca: "", anio: "", color: "" });
        toast({
          title: "Vehículo agregado",
          description: `${vehiculoGuardado.marca} ha sido agregado a la lista.`,
        });
      })
      .catch((error) => {
        console.error("Error al agregar el vehículo:", error);
        toast({
          title: "Error",
          description: "Hubo un problema al agregar el vehículo.",
          variant: "destructive",
        });
      });
  };

  

  const handleAsociarVehiculoMultiple = () => {
    if (!vehiculoSeleccionado) {
      toast({
        title: "Error",
        description: "Debe seleccionar un vehículo.",
        variant: "destructive",
      });
      return;
    }
  
    const clienteIds = [cliente.id]; // Add more client IDs as needed
  
    api
      .post(`/clientes/asociar-vehiculo-multiple`, {
        cliente_ids: clienteIds,
        vehiculo_id: vehiculoSeleccionado,
      })
      .then((response) => {
        const vehiculoAsociado = response.data;
        setCliente((prevCliente) => ({
          ...prevCliente,
          vehiculos: [...prevCliente.vehiculos, vehiculoAsociado],
        }));
        setShowAssociateVehicleForm(false);
        toast({
          title: "Vehículo asociado",
          description: "El vehículo ha sido asociado correctamente.",
        });
      })
      .catch((error) => {
        console.error("Error al asociar el vehículo:", error);
        toast({
          title: "Error",
          description: "Hubo un problema al asociar el vehículo.",
          variant: "destructive",
        });
      });
  };

  const handleEliminarEmbarcacion = (embarcacion) => {
    if (!embarcacion || !embarcacion.id) {
      toast({
        title: "Error",
        description: "No se pudo identificar la embarcación a desvincular.",
        variant: "destructive",
      });
      return;
    }

    api
      .delete(`/clientes/${cliente.id}/embarcaciones/${embarcacion.id}`)
      .then(() => {
        setCliente((prevCliente) => ({
          ...prevCliente,
          embarcaciones: (prevCliente.embarcaciones || []).filter(
            (item) => item.id !== embarcacion.id
          ),
        }));

        setEmbarcacionesDisponibles((prevDisponibles) => {
          const normalizada = normalizeEmbarcacionForDisplay(embarcacion);
          const disponibles = (prevDisponibles || []).filter(
            (item) => item.id !== embarcacion.id
          );
          return [...disponibles, normalizada];
        });

        toast({
          title: "Embarcación desvinculada",
          description: "La embarcación ha sido desvinculada del cliente.",
        });
      })
      .catch((error) => {
        console.error("Error al desvincular la embarcación:", error);
        toast({
          title: "Error",
          description:
            "No se pudo desvincular la embarcación. Intenta nuevamente más tarde.",
          variant: "destructive",
        });
      });
  };

  const handleEliminarVehiculo = (vehiculo) => {
    if (!vehiculo || !vehiculo.id) {
      toast({
        title: "Error",
        description: "No se pudo identificar el vehículo a eliminar.",
        variant: "destructive",
      });
      return;
    }

    api
      .delete(`/clientes/${cliente.id}/vehiculos/${vehiculo.id}`)
      .then(() => {
        setCliente((prevCliente) => ({
          ...prevCliente,
          vehiculos: (prevCliente.vehiculos || []).filter(
            (item) => item.id !== vehiculo.id
          ),
        }));
        toast({
          title: "Vehículo eliminado",
          description: "El vehículo ha sido desvinculado del cliente.",
        });
      })
      .catch((error) => {
        console.error("Error al eliminar el vehículo:", error);
        toast({
          title: "Error",
          description:
            "No se pudo desvincular el vehículo. Intenta nuevamente más tarde.",
          variant: "destructive",
        });
      });
  };

  const normalizeEmbarcacionForEdit = (embarcacion) =>
    normalizeEmbarcacionForDisplay(embarcacion);

  const handleEditEmbarcacion = (embarcacion) => {
    setEditandoEmbarcacion(normalizeEmbarcacionForEdit(embarcacion));
    setExpandedEmbarcacionId(embarcacion.id);
  };

  const handleSaveEmbarcacion = () => {
    api
      .put(
        `/embarcaciones/${editandoEmbarcacion.id}`,
        editandoEmbarcacion
      )
      .then((response) => {
        const updatedEmbarcacion = normalizeEmbarcacionForDisplay(
          response.data
        );
        setCliente({
          ...cliente,
          embarcaciones: cliente.embarcaciones.map((emb) =>
            emb.id === updatedEmbarcacion.id ? updatedEmbarcacion : emb
          ),
        });
        setEditandoEmbarcacion(null);
        setExpandedEmbarcacionId(null);
        toast({
          title: "Cambios guardados",
          description: "Los detalles de la embarcación han sido actualizados.",
        });
      })
      .catch((error) => {
        console.error("Error al guardar los cambios:", error);
        toast({
          title: "Error",
          description: "Hubo un problema al guardar los cambios.",
          variant: "destructive",
        });
      });
  };

  const handleCancelEditEmbarcacion = () => {
    setEditandoEmbarcacion(null);
    setExpandedEmbarcacionId(null);
  };

  const handleEditVehiculo = (vehiculo) => {
    setEditandoVehiculo(vehiculo);
  };

  const handleSaveVehiculo = () => {
    api
      .put(`/vehiculos/${editandoVehiculo.id}`, editandoVehiculo)
      .then((response) => {
        setEditandoVehiculo(null);
        toast({
          title: "Cambios guardados",
          description: "Los detalles del vehículo han sido actualizados.",
        });
      })
      .catch((error) => {
        console.error("Error al guardar los cambios:", error);
        toast({
          title: "Error",
          description: "Hubo un problema al guardar los cambios.",
          variant: "destructive",
        });
      });
  };

  const handleCancelEditVehiculo = () => {
    setEditandoVehiculo(null);
  };

  const handleIngresarAlAgua = (embarcacion) => {
  // Verificar si la embarcación ya está en el agua
  const embarcacionEnAgua = movimientos.some(
    mov => mov.embarcacion_id === embarcacion.id && mov.estado === "En el agua"
  );
  
  if (embarcacionEnAgua) {
    toast({
      title: "Error",
      description: `La embarcación con matrícula ${embarcacion.numeroMatricula} ya está en el agua.`,
      variant: "destructive",
    });
    return;
  }

  if (cliente.vehiculos.length > 1) {
    setShowVehiclePopup(true);
    setEmbarcacionSeleccionada(embarcacion);
  } else {
    const vehiculo = cliente.vehiculos[0];
    registrarMovimiento(embarcacion, vehiculo);
  }
};
  
  const registrarMovimiento = (embarcacion, vehiculo) => {
  if (!vehiculo || !vehiculo.id) {
    toast({
      title: "Error",
      description: "Debe seleccionar un vehículo válido.",
      variant: "destructive",
    });
    return;
  }
  
    // Verificar nuevamente por si hubo cambios
  const embarcacionEnAgua = movimientos.some(
    mov => mov.embarcacion_id === embarcacion.id && mov.estado === "En el agua"
  );
  
  if (embarcacionEnAgua) {
    toast({
      title: "Error",
      description: `La embarcación con matrícula ${embarcacion.numeroMatricula} ya está en el agua.`,
      variant: "destructive",
    });
    return;
  }
  
    const nuevoMovimiento = {
      cliente_id: cliente.id,
      embarcacion_id: embarcacion.id,
      vehiculo_id: vehiculo.id,
      tipo_movimiento: "Entrada",
      estado: "En el agua",
      fechaHoraIngreso: new Date().toISOString(),
      fechaMovimiento: new Date().toISOString(),
    };
  
    api.post("/movimientos", nuevoMovimiento)
      .then((response) => {
        toast({
          title: "Movimiento registrado",
          description: "La embarcación ha sido ingresada al agua.",
        });
  
        // Actualiza el estado de la embarcación en el cliente
        setCliente((prevCliente) => {
          const embarcacionesActualizadas = prevCliente.embarcaciones.map((emb) =>
            emb.id === embarcacion.id ? { ...emb, estado: "En el agua" } : emb
          );
          return { ...prevCliente, embarcaciones: embarcacionesActualizadas };
        });
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          toast({
            title: "Error",
            description: error.response.data.error,
            variant: "destructive",
          });
        } else {
          console.error("Error al registrar el movimiento:", error);
          toast({
            title: "Error",
            description: "Hubo un problema al registrar el movimiento.",
            variant: "destructive",
          });
        }
      });
  };

  const estaEnElAgua = (embarcacionId) => {
  return movimientos.some(m =>
    m.embarcacion_id === embarcacionId && m.estado === "En el agua"
  );
};
  
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const parsedDate = new Date(dateString);
    if (isNaN(parsedDate)) return "N/A";

    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return parsedDate.toLocaleDateString("es-ES", options);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blanco-puro to-gris-piedra">
      <Navbar />

      <main className="container mx-auto mt-8 px-4">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-4xl font-bold text-azul-oscuro flex items-center">
            <User className="mr-2" /> Detalles del Cliente
          </h1>
          <Button
            onClick={() => setEditando(!editando)}
            className={
              editando
                ? "bg-red-500 hover:bg-red-400"
                : "bg-azul-lago hover:bg-azul-claro"
            }
          >
            {editando ? (
              <X className="mr-2 h-4 w-4" />
            ) : (
              <Edit className="mr-2 h-4 w-4" />
            )}
            {editando ? "Cancelar" : "Editar"}
          </Button>
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Información del cliente */}
          <Card className="bg-white shadow-lg">
            <CardHeader>
              <CardTitle className="flex items-center text-azul-oscuro">
                <Info className="mr-2" /> Información Personal
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid gap-4">
                <div className="flex items-center justify-between">
                  <span className="font-semibold capitalize text-azul-oscuro">Cliente ID:</span>
                  <span className="text-azul-oscuro text-2xl font-bold">{cliente.id}</span>
                </div>
                {Object.entries(cliente).map(([key, value]) => {
                  if (typeof value === "string" && key !== "id" && key !== "createdAt" && key !== "updatedAt") {
                    return (
                      <div
                        key={key}
                        className="flex items-center justify-between"
                      >
                        <span className="font-semibold capitalize text-azul-oscuro">{key}:</span>
                        {editando ? (
                          <Input
                            value={value}
                            onChange={(e) => handleEdit(key, e.target.value)}
                            className="text-azul-oscuro"
                          />
                        ) : (
                          <span className="text-azul-oscuro">{key.includes('fecha') || key === 'vencimientoLicencia' || key === 'vencimientoSeguro' ? formatDate(value) : value}</span>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
              {editando && (
                <Button onClick={handleSave} className="bg-verde-esmeralda hover:bg-verde-oscuro mt-4">
                  <Save className="mr-2 h-4 w-4" /> Guardar Cambios
                </Button>
              )}
            </CardContent>
          </Card>

          {/* Resumen */}
          <Card className="bg-white shadow-lg">
            <CardHeader>
              <CardTitle className="text-2xl text-azul-oscuro">Resumen</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div>
                  <p className="text-lg font-semibold text-azul-oscuro">Embarcaciones</p>
                  <p className="text-3xl font-bold text-azul-oscuro">
                    {cliente.embarcaciones.length}
                  </p>
                </div>
                <div>
                  <p className="text-lg font-semibold text-azul-oscuro">Vehículos</p>
                  <p className="text-3xl font-bold text-azul-oscuro">
                    {cliente.vehiculos.length}
                  </p>
                </div>
                <div>
                  <p className="text-lg font-semibold text-azul-oscuro">Estado</p>
                  <Badge variant="outline" className="text-lg text-azul-oscuro">
                    Cliente Activo
                  </Badge>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

               {/* Embarcaciones */}
        <Card className="mt-8 bg-white shadow-lg">
          <CardHeader>
            <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
              <CardTitle className="flex items-center text-azul-oscuro">
                <Ship className="mr-2" /> Embarcaciones
              </CardTitle>
              <div className="flex flex-wrap gap-2">
                <Button
                  className="bg-azul-lago hover:bg-azul-claro"
                  onClick={() => setShowNewBoatForm(!showNewBoatForm)}
                >
                  <PlusCircle className="mr-2 h-4 w-4" /> {showNewBoatForm ? "Ocultar Formulario" : "Agregar Nueva Embarcación"}
                </Button>
                <Button
                  className="bg-azul-lago hover:bg-azul-claro"
                  onClick={() => setShowAssociateBoatForm(!showAssociateBoatForm)}
                >
                  <PlusCircle className="mr-2 h-4 w-4" /> {showAssociateBoatForm ? "Ocultar Formulario" : "Asociar Embarcación Existente"}
                </Button>
                <HistorialEmbarcacionesButton clienteId={id} />
              </div>
            </div>
          </CardHeader>
          <CardContent>
            {showNewBoatForm && (
              <div className="grid gap-6 py-6">
                {/* Número de Matrícula */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="numeroMatricula" className="text-right text-lg text-azul-oscuro">
                    Número de Matrícula *
                  </Label>
                  <Input
                    id="numeroMatricula"
                    type="text"
                    maxLength="50"
                    required
                    value={nuevaEmbarcacion.numeroMatricula}
                    onChange={(e) =>
                      setNuevaEmbarcacion({
                        ...nuevaEmbarcacion,
                        numeroMatricula: e.target.value,
                      })
                    }
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="vencimientoMatricula" className="text-right text-lg text-azul-oscuro">
                    Vencimiento de Matrícula
                  </Label>
                  <Input
                    id="vencimientoMatricula"
                    type="date"
                    value={nuevaEmbarcacion.vencimientoMatricula}
                    onChange={(e) =>
                      setNuevaEmbarcacion({
                        ...nuevaEmbarcacion,
                        vencimientoMatricula: e.target.value,
                      })
                    }
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                {/* Tipo de Embarcación */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="tipoEmbarcacion" className="text-right text-lg text-azul-oscuro">
                    Tipo de Embarcación
                  </Label>
                  <Select
                    name="tipoEmbarcacion"
                    value={nuevaEmbarcacion.tipoEmbarcacion}
                    onValueChange={handleValueChange}
                  >
                    <SelectTrigger
                      id="tipoEmbarcacion"
                      className="text-lg py-2 px-4 text-azul-oscuro"
                    >
                      <SelectValue placeholder="Seleccioná un tipo de embarcación" />
                    </SelectTrigger>
                    <SelectContent>
                      {TIPOS_EMBARCACION.map((tipo) => (
                        <SelectItem key={tipo.value} value={tipo.value}>
                          {tipo.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                {/* Color del Casco */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="colorCasco" className="text-right text-lg text-azul-oscuro">
                    Color del Casco
                  </Label>
                  <Input
                    id="colorCasco"
                    type="text"
                    maxLength="50"
                    value={nuevaEmbarcacion.colorCasco}
                    onChange={(e) =>
                      setNuevaEmbarcacion({
                        ...nuevaEmbarcacion,
                        colorCasco: e.target.value,
                      })
                    }
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                {/* Capacidad */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="capacidad" className="text-right text-lg text-azul-oscuro">
                    Capacidad
                  </Label>
                  <Input
                    id="capacidad"
                    type="number"
                    min="1"
                    value={nuevaEmbarcacion.capacidad}
                    onChange={(e) =>
                      setNuevaEmbarcacion({
                        ...nuevaEmbarcacion,
                        capacidad: parseInt(e.target.value) || "",
                      })
                    }
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                {/* Marca */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="marca" className="text-right text-lg text-azul-oscuro">
                    Marca
                  </Label>
                  <Input
                    id="marca"
                    type="text"
                    maxLength="50"
                    value={nuevaEmbarcacion.marca}
                    onChange={(e) =>
                      setNuevaEmbarcacion({
                        ...nuevaEmbarcacion,
                        marca: e.target.value,
                      })
                    }
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                {/* HP */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="hp" className="text-right text-lg text-azul-oscuro">
                    HP
                  </Label>
                  <Input
                    id="hp"
                    type="number"
                    min="1"
                    value={nuevaEmbarcacion.hp}
                    onChange={(e) =>
                      setNuevaEmbarcacion({
                        ...nuevaEmbarcacion,
                        hp: parseInt(e.target.value) || "",
                      })
                    }
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                {/* Nombre de Fantasía */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="nombreFantasia" className="text-right text-lg text-azul-oscuro">
                    Nombre de Fantasía
                  </Label>
                  <Input
                    id="nombreFantasia"
                    type="text"
                    maxLength="100"
                    value={nuevaEmbarcacion.nombreFantasia}
                    onChange={(e) =>
                      setNuevaEmbarcacion({
                        ...nuevaEmbarcacion,
                        nombreFantasia: e.target.value,
                      })
                    }
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                {/* Seguro */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="seguro" className="text-right text-lg text-azul-oscuro">
                    Seguro
                  </Label>
                  <Input
                    id="seguro"
                    type="text"
                    maxLength="50"
                    value={nuevaEmbarcacion.seguro}
                    onChange={(e) =>
                      setNuevaEmbarcacion({
                        ...nuevaEmbarcacion,
                        seguro: e.target.value,
                      })
                    }
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                {/* Vencimiento del Seguro */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="vencimientoSeguro" className="text-right text-lg text-azul-oscuro">
                    Vencimiento del Seguro
                  </Label>
                  <Input
                    id="vencimientoSeguro"
                    type="date"
                    value={nuevaEmbarcacion.vencimientoSeguro}
                    onChange={(e) =>
                      setNuevaEmbarcacion({
                        ...nuevaEmbarcacion,
                        vencimientoSeguro: e.target.value,
                      })
                    }
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                <Button onClick={handleAgregarEmbarcacion} className="bg-verde-esmeralda hover:bg-verde-oscuro text-lg py-2 px-4">
                  Agregar Embarcación
                </Button>
                
              </div>
            )}
            {showAssociateBoatForm && (
  <div className="grid gap-6 py-6">
    <div className="grid grid-cols-4 items-center gap-4">
      <Label htmlFor="searchEmbarcacion" className="text-right text-lg text-azul-oscuro">
        Buscar Embarcación
      </Label>
      <Input
        id="searchEmbarcacion"
        type="text"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Buscar por matrícula, nombre o ID"
        className="text-lg py-2 px-4 text-azul-oscuro"
      />
    </div>
    {searchTerm && (
      <div className="grid grid-cols-4 items-center gap-4">
        <Label className="text-right text-lg text-azul-oscuro">
          Embarcaciones Disponibles
        </Label>
        <div className="col-span-3">
          {filteredEmbarcaciones.map((embarcacion) => (
            <div
              key={embarcacion.id}
              className={`p-2 border rounded cursor-pointer ${embarcacionSeleccionada === embarcacion.id ? 'bg-azul-claro' : 'bg-white'}`}
              onClick={() => setEmbarcacionSeleccionada(embarcacion.id)}
            >
              {embarcacion.numeroMatricula} - {embarcacion.nombreFantasia}
            </div>
          ))}
        </div>
      </div>
    )}
        <Button onClick={handleAsociarEmbarcacionMultiple} className="bg-verde-esmeralda hover:bg-verde-oscuro text-lg py-2 px-4">
      Asociar Embarcación
    </Button>
  </div>
)}
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="text-azul-oscuro">Número de Matrícula</TableHead>
                  <TableHead className="text-azul-oscuro">Tipo de Embarcación</TableHead>
                  <TableHead className="text-azul-oscuro">Color del Casco</TableHead>
                  <TableHead className="text-azul-oscuro">Capacidad</TableHead>
                  <TableHead className="text-azul-oscuro">Marca</TableHead>
                  <TableHead className="text-azul-oscuro">HP</TableHead>
                  <TableHead className="text-azul-oscuro">Nombre de Fantasía</TableHead>
                  <TableHead className="text-azul-oscuro">Seguro</TableHead>
                  <TableHead className="text-azul-oscuro">Vencimiento Matrícula</TableHead>
                  <TableHead className="text-azul-oscuro">Vencimiento del Seguro</TableHead>
                  <TableHead className="text-azul-oscuro">Acciones</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {cliente.embarcaciones.map((embarcacion) => (
                  <React.Fragment key={embarcacion.numeroMatricula}>
                    <TableRow>
                      <TableCell>{embarcacion.numeroMatricula}</TableCell>
                      <TableCell>{embarcacion.tipoEmbarcacion}</TableCell>
                      <TableCell>{embarcacion.colorCasco}</TableCell>
                      <TableCell>{embarcacion.capacidad}</TableCell>
                      <TableCell>{embarcacion.marca}</TableCell>
                      <TableCell>{embarcacion.hp}</TableCell>
                      <TableCell>{embarcacion.nombreFantasia}</TableCell>
                      <TableCell>{embarcacion.seguro}</TableCell>
                      <TableCell>
                        {formatDate(embarcacion.vencimientoMatricula)}
                        {isDateExpired(embarcacion.vencimientoMatricula) && (
                          <span className="text-red-500 ml-2 flex items-center">
                            <AlertTriangle className="mr-1" /> ¡Vencido!
                          </span>
                        )}
                      </TableCell>
                      <TableCell>
                        {formatDate(embarcacion.vencimientoSeguro)}
                        {isDateExpired(embarcacion.vencimientoSeguro) && (
                          <span className="text-red-500 ml-2 flex items-center">
                            <AlertTriangle className="mr-1" /> ¡Vencido!
                          </span>
                        )}
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="outline"
                          size="sm"
                          className="mr-2"
                          onClick={() => handleEditEmbarcacion(embarcacion)}
                        >
                          {expandedEmbarcacionId === embarcacion.id ? <X className="h-4 w-4" /> : <Edit className="h-4 w-4" />}
                          {expandedEmbarcacionId === embarcacion.id ? "Cancelar" : "Editar"}
                        </Button>
                        <Button
                          variant="outline"
                          size="sm"
                          className="mr-2 text-red-600 border-red-300 hover:bg-red-50"
                          onClick={() => handleEliminarEmbarcacion(embarcacion)}
                        >
                          <Trash className="h-4 w-4" /> Desvincular
                        </Button>
                        {estaEnElAgua(embarcacion.id) ? (
  <Button
    variant="outline"
    size="sm"
    className="mr-2 text-blue-600 border-blue-300 bg-blue-100 cursor-default"
    disabled
  >
    <Ship className="h-4 w-4 mr-1 animate-bounce" />
    En el Agua
  </Button>
) : (
  <Button
    variant="outline"
    size="sm"
    className="mr-2"
    onClick={() => handleIngresarAlAgua(embarcacion)}
  >
    <Anchor className="h-4 w-4" /> Ingresar al Agua
  </Button>
)}

                      </TableCell>
                    </TableRow>
                    {expandedEmbarcacionId === embarcacion.id && (
                      <TableRow>
                        <TableCell colSpan={11}>
                          <div className="p-4 bg-gray-100 rounded-lg">
                            <div className="grid gap-6 py-6">
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="numeroMatricula" className="text-right text-lg text-azul-oscuro">
                                  Número de Matrícula
                                </Label>
                                <Input
                                  id="numeroMatricula"
                                  type="text"
                                  value={editandoEmbarcacion?.numeroMatricula || ''}
                                  onChange={(e) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      numeroMatricula: e.target.value,
                                    })
                                  }
                                  className="text-lg py-2 px-4 text-azul-oscuro"
                                />
                              </div>
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="tipoEmbarcacion" className="text-right text-lg text-azul-oscuro">
                                  Tipo de Embarcación
                                </Label>
                                <Select
                                  name="tipoEmbarcacion"
                                  value={editandoEmbarcacion?.tipoEmbarcacion || ''}
                                  onValueChange={(value) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      tipoEmbarcacion: value,
                                    })
                                  }
                                >
                                  <SelectTrigger
                                    id="tipoEmbarcacionEdit"
                                    className="text-lg py-2 px-4 text-azul-oscuro"
                                  >
                                    <SelectValue placeholder="Seleccioná un tipo de embarcación" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    {TIPOS_EMBARCACION.map((tipo) => (
                                      <SelectItem key={tipo.value} value={tipo.value}>
                                        {tipo.label}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                              </div>
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="colorCasco" className="text-right text-lg text-azul-oscuro">
                                  Color del Casco
                                </Label>
                                <Input
                                  id="colorCasco"
                                  type="text"
                                  value={editandoEmbarcacion?.colorCasco || ''}
                                  onChange={(e) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      colorCasco: e.target.value,
                                    })
                                  }
                                  className="text-lg py-2 px-4 text-azul-oscuro"
                                />
                              </div>
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="capacidad" className="text-right text-lg text-azul-oscuro">
                                  Capacidad
                                </Label>
                                <Input
                                  id="capacidad"
                                  type="number"
                                  value={editandoEmbarcacion?.capacidad || ''}
                                  onChange={(e) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      capacidad: e.target.value,
                                    })
                                  }
                                  className="text-lg py-2 px-4 text-azul-oscuro"
                                />
                              </div>
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="marca" className="text-right text-lg text-azul-oscuro">
                                  Marca
                                </Label>
                                <Input
                                  id="marca"
                                  type="text"
                                  value={editandoEmbarcacion?.marca || ''}
                                  onChange={(e) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      marca: e.target.value,
                                    })
                                  }
                                  className="text-lg py-2 px-4 text-azul-oscuro"
                                />
                              </div>
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="hp" className="text-right text-lg text-azul-oscuro">
                                  HP
                                </Label>
                                <Input
                                  id="hp"
                                  type="number"
                                  value={editandoEmbarcacion?.hp || ''}
                                  onChange={(e) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      hp: e.target.value,
                                    })
                                  }
                                  className="text-lg py-2 px-4 text-azul-oscuro"
                                />
                              </div>
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="nombreFantasia" className="text-right text-lg text-azul-oscuro">
                                  Nombre de Fantasía
                                </Label>
                                <Input
                                  id="nombreFantasia"
                                  type="text"
                                  value={editandoEmbarcacion?.nombreFantasia || ''}
                                  onChange={(e) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      nombreFantasia: e.target.value,
                                    })
                                  }
                                  className="text-lg py-2 px-4 text-azul-oscuro"
                                />
                              </div>
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="seguro" className="text-right text-lg text-azul-oscuro">
                                  Seguro
                                </Label>
                                <Input
                                  id="seguro"
                                  type="text"
                                  value={editandoEmbarcacion?.seguro || ''}
                                  onChange={(e) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      seguro: e.target.value,
                                    })
                                  }
                                  className="text-lg py-2 px-4 text-azul-oscuro"
                                />
                              </div>
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="vencimientoMatricula" className="text-right text-lg text-azul-oscuro">
                                  Vencimiento de Matrícula
                                </Label>
                                <Input
                                  id="vencimientoMatricula"
                                  type="date"
                                  value={editandoEmbarcacion?.vencimientoMatricula || ''}
                                  onChange={(e) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      vencimientoMatricula: e.target.value,
                                    })
                                  }
                                  className="text-lg py-2 px-4 text-azul-oscuro"
                                />
                              </div>
                              <div className="grid grid-cols-4 items-center gap-4">
                                <Label htmlFor="vencimientoSeguro" className="text-right text-lg text-azul-oscuro">
                                  Vencimiento del Seguro
                                </Label>
                                <Input
                                  id="vencimientoSeguro"
                                  type="date"
                                  value={editandoEmbarcacion?.vencimientoSeguro || ''}
                                  onChange={(e) =>
                                    setEditandoEmbarcacion({
                                      ...editandoEmbarcacion,
                                      vencimientoSeguro: e.target.value,
                                    })
                                  }
                                  className="text-lg py-2 px-4 text-azul-oscuro"
                                />
                              </div>
                              <div className="flex justify-end mt-4">
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="mr-2"
                                  onClick={handleSaveEmbarcacion}
                                >
                                  <Save className="h-4 w-4" /> Guardar cambios
                                </Button>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={handleCancelEditEmbarcacion}
                                >
                                  <X className="h-4 w-4" /> Cancelar
                                </Button>
                              </div>
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        {/* Vehículos */}
        <Card className="mt-8 bg-white shadow-lg">
          <CardHeader>
            <CardTitle>
              <div className="flex items-center text-azul-oscuro">
                <Car className="mr-2" /> Vehículos
              </div>
              <Button
                className="bg-azul-lago hover:bg-azul-claro"
                onClick={() => setShowNewVehicleForm(!showNewVehicleForm)}
              >
                <PlusCircle className="mr-2 h-4 w-4" /> {showNewVehicleForm ? "Ocultar Formulario" : "Agregar Nuevo Vehículo"}
              </Button>
              <Button
                className="bg-azul-lago hover:bg-azul-claro"
                onClick={() => setShowAssociateVehicleForm(!showAssociateVehicleForm)}
              >
                <PlusCircle className="mr-2 h-4 w-4" /> {showAssociateVehicleForm ? "Ocultar Formulario" : "Asociar Vehículo Existente"}
              </Button>
            </CardTitle>
          </CardHeader>
          <CardContent>
            {showNewVehicleForm && (
              <div className="grid gap-6 py-6">
                {/* Campo: Patente */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="patente" className="text-right text-lg text-azul-oscuro">
                    Patente
                  </Label>
                  <Input
                    id="patente"
                    value={nuevoVehiculo.patente}
                    maxLength={20}
                    onChange={(e) =>
                      setNuevoVehiculo({
                        ...nuevoVehiculo,
                        patente: e.target.value.trim(),
                      })
                    }
                    placeholder="Ej: ABC123"
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                  {nuevoVehiculo.patente && nuevoVehiculo.patente.length < 6 && (
                    <span className="text-red-500 text-sm">
                      La patente debe tener entre 6 y 20 caracteres.
                    </span>
                  )}
                </div>

                {/* Campo: Marca */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="marca" className="text-right text-lg text-azul-oscuro">
                    Marca
                  </Label>
                  <Input
                    id="marca"
                    value={nuevoVehiculo.marca}
                    maxLength={50}
                    onChange={(e) =>
                      setNuevoVehiculo({
                        ...nuevoVehiculo,
                        marca: e.target.value.trim(),
                      })
                    }
                    placeholder="Ej: Toyota"
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                  {!nuevoVehiculo.marca && (
                    <span className="text-red-500 text-sm">
                      La marca es obligatoria.
                    </span>
                  )}
                </div>

                {/* Campo: Año */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="anio" className="text-right text-lg text-azul-oscuro">
                    Año
                  </Label>
                  <Input
                    id="anio"
                    type="number"
                    value={nuevoVehiculo.anio}
                    onChange={(e) => {
                      const anio = parseInt(e.target.value, 10);
                      setNuevoVehiculo({ ...nuevoVehiculo, anio });
                    }}
                    placeholder="Ej: 2023"
                    min={1900}
                    max={new Date().getFullYear()}
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                  {(nuevoVehiculo.anio < 1900 || nuevoVehiculo.anio > new Date().getFullYear()) && (
                    <span className="text-red-500 text-sm">
                      El año debe ser entre 1900 y el actual.
                    </span>
                  )}
                </div>

                {/* Campo: Color */}
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="color" className="text-right text-lg text-azul-oscuro">
                    Color
                  </Label>
                  <Input
                    id="color"
                    value={nuevoVehiculo.color}
                    maxLength={50}
                    onChange={(e) =>
                      setNuevoVehiculo({
                        ...nuevoVehiculo,
                        color: e.target.value.trim(),
                      })
                    }
                    placeholder="Ej: Azul"
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                  {!nuevoVehiculo.color && (
                    <span className="text-red-500 text-sm">
                      El color es obligatorio.
                    </span>
                  )}
                </div>
              </div>
            )}
             <Button onClick={handleAgregarVehiculo} className="bg-verde-esmeralda hover:bg-verde-oscuro text-lg py-2 px-4">
              Agregar Vehículo
            </Button>

            {showAssociateVehicleForm && (
              <div className="grid gap-6 py-6">
                <div className="grid grid-cols-4 items-center gap-4">
                  <Label htmlFor="searchVehiculo" className="text-right text-lg text-azul-oscuro">
                    Buscar Vehículo
                  </Label>
                  <Input
                    id="searchVehiculo"
                    type="text"
                    value={searchTermVehiculo}
                    onChange={(e) => setSearchTermVehiculo(e.target.value)}
                    placeholder="Buscar por patente o marca"
                    className="text-lg py-2 px-4 text-azul-oscuro"
                  />
                </div>
                {searchTermVehiculo && (
                  <div className="grid grid-cols-4 items-center gap-4">
                    <Label className="text-right text-lg text-azul-oscuro">
                      Vehículos Disponibles
                    </Label>
                    <div className="col-span-3">
                      {filteredVehiculos.map((vehiculo) => (
                        vehiculo && (
                          <div
                            key={vehiculo.id}
                            className={`p-2 border rounded cursor-pointer ${vehiculoSeleccionado === vehiculo.id ? 'bg-azul-claro' : 'bg-white'}`}
                            onClick={() => setVehiculoSeleccionado(vehiculo.id)}
                          >
                            {vehiculo.patente} - {vehiculo.marca}
                          </div>
                        )
                      ))}
                    </div>
                  </div>
                )}
               <Button onClick={handleAsociarVehiculoMultiple} className="bg-verde-esmeralda hover:bg-verde-oscuro text-lg py-2 px-4">
                  Asociar Vehículo
                </Button>
              </div>
            )}
            {showVehiclePopup && (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-xl font-bold mb-4">Seleccionar Vehículo</h2>
        <select
          className="text-lg py-2 px-4 text-azul-oscuro border-2 border-gray-300 rounded-lg mb-4"
          onChange={(e) => {
            const vehiculo = cliente.vehiculos.find(v => v.id === parseInt(e.target.value));
            if (vehiculo) {
              setVehiculoSeleccionado(vehiculo);
            } else {
              toast({
                title: "Error",
                description: "Debe seleccionar un vehículo válido.",
                variant: "destructive",
              });
            }
          }}
        >
          <option value="">Seleccione un vehículo</option>
          {cliente.vehiculos.map((vehiculo) => (
            <option key={vehiculo.id} value={vehiculo.id}>
              {vehiculo.marca} - {vehiculo.patente}
            </option>
          ))}
        </select>
        <div className="flex justify-end">
          <Button
            onClick={() => {
              if (vehiculoSeleccionado) {
                registrarMovimiento(embarcacionSeleccionada, vehiculoSeleccionado);
                setShowVehiclePopup(false);
              } else {
                toast({
                  title: "Error",
                  description: "Debe seleccionar un vehículo válido.",
                  variant: "destructive",
                });
              }
            }}
            className="bg-verde-esmeralda hover:bg-verde-oscuro mr-2"
          >
            Confirmar
          </Button>
          <Button
            onClick={() => setShowVehiclePopup(false)}
            className="bg-red-500 hover:bg-red-400"
          >
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  )}
            <ScrollArea className="h-[300px]">
  <Table>
    <TableHeader>
      <TableRow>
        <TableHead className="text-azul-oscuro">Patente</TableHead>
        <TableHead className="text-azul-oscuro">Marca</TableHead>
        <TableHead className="text-azul-oscuro">Año</TableHead>
        <TableHead className="text-azul-oscuro">Color</TableHead>
        <TableHead className="text-azul-oscuro">Acciones</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {cliente.vehiculos.filter(Boolean).map((vehiculo) => (
        vehiculo && (
          <TableRow key={vehiculo.id || vehiculo.patente}>
            <TableCell>{vehiculo.patente}</TableCell>
            <TableCell>{vehiculo.marca}</TableCell>
            <TableCell>{vehiculo.anio}</TableCell>
            <TableCell>{vehiculo.color}</TableCell>
            <TableCell>
              <Button
                variant="outline"
                size="sm"
                className="mr-2"
                onClick={() => handleEditVehiculo(vehiculo)}
              >
                <Edit className="h-4 w-4" /> Editar
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleEliminarVehiculo(vehiculo)}
              >
                <Trash className="h-4 w-4" /> Eliminar
              </Button>
            </TableCell>
          </TableRow>
        )
      ))}
    </TableBody>
  </Table>
</ScrollArea>
          </CardContent>
        </Card>
      </main>
      
    </div>
  );
};

export default DetallesClientesPage;
